// TODO: Move this to utils
export const isFeatureEnabled = (config, feature) => {

  return config?.feature_toggles?.includes(feature);
};